import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import CssBaseline from '@material-ui/core/CssBaseline'
import Polyglot from 'node-polyglot'
import 'react-toastify/dist/ReactToastify.min.css'
import './styles/globalStyles.css'
import * as Translations from './translations'
import store from './store'
import * as serviceWorker from './utils/serviceWorker'
import App from './modules/App'

window.I18n = new Polyglot(Translations.English)

ReactDOM.render(
  <Provider store={store}>
    <CssBaseline>
      <App />
    </CssBaseline>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
